






























































































































































import Vue from "vue";
import VueHtml2pdf from "vue-html2pdf";
import Component from "vue-class-component";
import { Quiz } from "@/model/ResponseModel";

@Component({
  name: "Result",
  components: { VueHtml2pdf }
  // Toutes les options de composant sont autorisées ici.
})
export default class Result extends Vue {
  data: Quiz = this.$store.state.quizzes;
  image = require("@/assets/logo.png");
  series: any[] = [];
  chartOptions: any[] = [];
  dataResult = [
    {
      name: "verte",
      color: "#00E676",
      zone: "Non significatif",
      sub: [] as string[]
    },
    {
      name: "orange",
      color: "#FEAF19",
      zone: "À surveiller",
      sub: [] as string[]
    },
    {
      name: "rouge",
      color: "#F4511D",
      zone: "À risque",
      sub: [] as string[]
    }
  ];
  mounted() {
    for (const subject of this.data.subjects) {
      const options = {
        tooltip: {
          enabled: false,
          y: {
            formatter: function(val: any, opt: any) {
              let sum = 0;
              for (let i = 0; i < opt.seriesIndex + 1; i++) {
                sum += subject.ranking[i];
              }

              let sum2 = 0;
              for (let i = 0; i < opt.seriesIndex; i++) {
                sum2 += subject.ranking[i];
              }
              return sum2 + " - " + sum;
            }
          }
        },
        chart: {
          toolbar: {
            show: false
          },
          type: "bar",
          height: 200,
          stacked: true,
          stackType: "normal"
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        dataLabels: {
          formatter: function(val: any, opt: any) {
            let sum = 0;
            for (let i = 0; i < opt.seriesIndex + 1; i++) {
              sum += subject.ranking[i];
            }

            let sum2 = 0;
            for (let i = 0; i < opt.seriesIndex; i++) {
              sum2 += subject.ranking[i];
            }
            return sum2 + " - " + sum;
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        title: {
          text: subject.name
        },
        xaxis: {
          categories: [""],
          max: 24,
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40
        }
      };
      this.chartOptions.push(options);
      this.series.push([
        {
          name: "Non significatif",
          data: [subject.ranking[0]],
          color: "#00E676"
        },
        {
          name: "À surveiller",
          data: [subject.ranking[1]],
          color: "#FEAF19"
        },
        {
          name: "À risque",
          data: [subject.ranking[2]],
          color: "#F4511D"
        }
      ]);
      const color = this.computeColor(subject.ranking, subject.score);
      if (subject.disable) {
        this.dataResult[0].sub.push(subject.name);
      } else {
        color.sub.push(subject.name);
      }
    }
  }

  generateReport() {
    (this.$refs.html2Pdf as any).generatePdf();
  }

  computeColor(ranking: number[], score: number) {
    let sum = 0;
    for (let i = 0; i < ranking.length; i++) {
      const rank = ranking[i];
      sum += rank;
      if (score < sum) {
        return this.dataResult[i];
      }
    }
    return this.dataResult[ranking.length - 1];
  }
}
